<xemex-card
  [title]="'devices.pvForecast.title' | translate"
  [actionLabel]="store.config() ? ('general.btnEdit' | translate) : ''"
  actionIcon="edit"
  [loading]="store.isLoading()"
  (action)="openEditDialog()"
>
  <div class="flex flex-col gap-4">
    <div class="flex items-start justify-between gap-6">
      <div class="flex flex-col gap-1">
        <span class="text-sm font-medium">
          {{ 'devices.pvForecast.enable.label' | translate }}
        </span>
        <span class="text-sm text-text-secondary">
          {{ 'devices.pvForecast.enable.description' | translate }}
        </span>
        @if (wrongMeterRole()) {
          <span class="text-sm text-text-secondary">
            {{ 'devices.pvForecast.enable.productionOnly' | translate }}
          </span>
        }
      </div>
      <mat-slide-toggle
        #toggle
        [checked]="active()"
        [disabled]="isSaving() || store.isLoading() || enableBlocked()"
        (change)="onToggleChange($event)"
      />
    </div>

    @if (active() && store.config(); as config) {
      <div class="flex flex-col divide-y divide-gray-100">
        @for (array of config.pv_arrays; track $index) {
          <div class="flex items-start justify-between gap-4 py-2 text-sm">
            <span class="font-medium text-text-default">
              {{ 'devices.pvForecast.dialog.arrayTitle' | translate: { number: $index + 1 } }}
            </span>
            <div class="flex flex-col items-end gap-0.5 text-right text-text-secondary">
              <span>
                {{
                  'devices.pvForecast.summaryTilt' | translate: { value: tiltDisplay(array.tilt) }
                }}
              </span>
              <span>
                {{
                  'devices.pvForecast.summaryOrientation'
                    | translate: { value: azimuthDisplay(array.azimuth) }
                }}
              </span>
              <span>
                {{ 'devices.pvForecast.summaryKwp' | translate: { value: kwpDisplay(array.wp) } }}
              </span>
            </div>
          </div>
        }
      </div>
    }
  </div>
</xemex-card>
